import { baseLookup } from '@api/lookupClient'
import { useState, useEffect } from 'react'

const cache: Record<string, { label: string; value: string }[]> = {}

export const TSADecisionTimeframe = '60 days'

export enum KEYS {
  'us-born-citizenship-immigration-documents' = 'us-born-citizenship-immigration-documents',
  'subdivisions-ca' = 'subdivisions-ca',
  'preferred-contact-methods' = 'preferred-contact-methods',
  'uploadable-proofs-of-citizenship' = 'uploadable-proofs-of-citizenship',
  'hair-colors' = 'hair-colors',
  'subdivisions-mx' = 'subdivisions-mx',
  'non-us-born-citizenship-immigration-documents' = 'non-us-born-citizenship-immigration-documents',
  'non-us-citizen-photo-ids' = 'non-us-citizen-photo-ids',
  'subdivisions-us' = 'subdivisions-us',
  'name-suffixes' = 'name-suffixes',
  'genders' = 'genders',
  'non-immigrant-visa-statuses' = 'non-immigrant-visa-statuses',
  'eye-colors' = 'eye-colors',
  'us-citizen-photo-ids' = 'us-citizen-photo-ids',
  'countries' = 'countries',
}

export default function useLookupData(
  keys: KEYS[]
): [Record<string, { label: string; value: string }[]>, boolean] {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState<
    Record<string, { label: string; value: string }[]>
  >({})

  useEffect(() => {
    setIsLoading(true)
    const fetchData = async () => {
      const d: Record<string, { label: string; value: string }[]> = {}
      await Promise.all(
        keys.map(async (key) => {
          if (!cache[key]) {
            const val = await baseLookup(key)
            cache[key] = val
          }
          d[key] = cache[key]
          return cache[key]
        })
      )
      setData(d)
      setIsLoading(false)
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [data, isLoading]
}
